import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'kaldewei',
} as IModuleProps;
